import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLayout } from "../../LayoutContext";
import { UserStoryVisualDto } from "../dto/UserStoryVisualDto";
import { api } from "../../../interceptors/api";
import "./styles/WerkschauSelector.css";

const deviceMap = [
  {
    id: 1,
    slug: "tape",
    label: "Cassette Tape",
    url: "tape",
    image: "/assets/werkschau/cassette_tape.png",
  },
  {
    id: 2,
    slug: "ipod",
    label: "Apple iPod",
    url: "ipod",
    image: "/assets/werkschau/ipod_photo.png",
    background: "/assets/werkschau/ipod_photo_bg.png",
  },
  {
    id: 3,
    slug: "echo",
    label: "Amazon Echo",
    url: "echo",
    image: "/assets/werkschau/echo_dot.png",
  },
];

function WerkschauSelector() {
  /*const [stories, setStories] = useState<Record<number, string>>({});*/
  const [tapeVisuals, setTapeVisuals] = useState<UserStoryVisualDto[]>([]);
  const [error, setError] = useState<string | null>(null);
  const { setExhibitionMode } = useLayout();
  const navigate = useNavigate();

  useEffect(() => {
    setExhibitionMode(true);
    return () => {
      setExhibitionMode(false);
    };
  }, [setExhibitionMode]);

  /*useEffect(() => {
    // fetch all three device story URLs at once
    api
      .get<DeviceStoryDto[]>(
        `/api/device-story/devices/${[1, 2, 3].join(",")}/exhibition/1`,
      )
      .then((res) => {
        const map: Record<number, string> = {};
        res.data.forEach((ds) => (map[ds.deviceId] = ds.audioUrl));
        setStories(map);
      })
      .catch((err) => {
        console.error(err);
        setError("Device-Stories konnten nicht geladen werden.");
      });
  }, []);*/

  useEffect(() => {
    api
      .get<UserStoryVisualDto[]>("/api/user-story/visuals/device/1")
      .then((res) => setTapeVisuals(res.data))
      .catch(() => console.error("Failed to load story visuals:"));
  }, []);

  const backgroundStyle = useMemo<React.CSSProperties>(() => {
    const layers = [`url('${deviceMap.find((d) => d.id === 1)!.background}')`];

    if (tapeVisuals.length) {
      // Shuffle and take up to, say, 4 visuals
      const shuffled = [...tapeVisuals]
        .sort(() => Math.random() - 0.5)
        .slice(0, 4);
      shuffled.forEach((v) => {
        layers.push(`url('${v.visualUrl}')`);
      });
    }

    return {
      backgroundImage: layers.join(", "),
      backgroundRepeat: "repeat, no-repeat, no-repeat, no-repeat, no-repeat",
      backgroundSize: "auto, cover, cover, cover, cover",
      backgroundPosition: "center center",
    };
  }, [tapeVisuals]);

  const handleNavigate = (url: string) => {
    navigate(`/exhibits/werkschau/${url}`, {
      replace: true,
      state: { backgroundStyle },
    });
  };

  return (
    <div className="werkschau-selector">
      <div className="werkschau-title">
        <h1>
          From cassettes to playlists and streaming – explore how music
          consumption has evolved, hear each device’s story, and share your
          memories to help them grow.
        </h1>
        <p>Click on device</p>
        {error && <div className="error">{error}</div>}
      </div>

      <div className="device-grid">
        {deviceMap.map((dev) => (
          <div
            onClick={() => handleNavigate(dev.url)}
            className={`device-container device-container-${dev.slug}`}
            key={dev.id}
            style={
              dev.id === 1
                ? backgroundStyle
                : {
                    backgroundImage: `url('${dev.background}')`,
                    backgroundSize: "cover",
                  }
            }
          >
            <div className={`device-container-inner-${dev.slug}`}></div>
            <div className={`device-card device-card-${dev.slug}`}>
              <div className={`device-icon device-icon-${dev.slug}`}>
                <img src={dev.image} alt={dev.label} />
              </div>
              <div
                className={`device-card-label-action device-card-label-action-${dev.slug}`}
              >
                <h2>{dev.label}</h2>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WerkschauSelector;
